import type { OrderListItem } from "../../types";

interface OrderCardProps {
  order: OrderListItem;
  isActive: boolean;
  isLoading: boolean;
  onShowDetails: (order: OrderListItem) => void;
  formatOrderLabel: (order: OrderListItem) => string;
  formatDateTime: (value?: string) => string;
  formatDate: (value?: string) => string;
  formatCurrency: (value?: number | null) => string;
  getOrderStatusLabel: (order: OrderListItem) => string;
}

const OrderCard = ({
  order,
  isActive,
  isLoading,
  onShowDetails,
  formatOrderLabel,
  formatDateTime,
  formatDate,
  formatCurrency,
  getOrderStatusLabel,
}: OrderCardProps) => (
  <article className={`order-card${isActive ? " active" : ""}`}>
    <header>
      <h3>{formatOrderLabel(order)}</h3>
      <span>{formatDateTime(order.placedAt)}</span>
    </header>
    <p>
      Status: <strong>{getOrderStatusLabel(order)}</strong>
    </p>
    <p>Pozycje: {order.itemCount}</p>
    <p>Dostawa: {formatDate(order.deliveryDate) || "–"}</p>
    <footer>
      <span>
        Razem: <strong>{formatCurrency(order.total)}</strong>
      </span>
      <button
        type="button"
        className="secondary"
        onClick={() => onShowDetails(order)}
        aria-pressed={isActive}
        aria-busy={isLoading}
        disabled={isLoading}
      >
        Podgląd
        {isLoading && <span className="button-spinner" aria-hidden="true" />}
      </button>
    </footer>
  </article>
);

export default OrderCard;
